$(function(){
  /*swiper スライド ランキング用*/
  var swiper = new Swiper('.swiper-container01', {
    navigation: { 
      nextEl: '.swiper-related-button-next01',
      prevEl: '.swiper-related-button-prev01',
    },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 2,
		spaceBetween: 32,
		breakpoints: {
			// 500px以上の場合
			500: {
				slidesPerView: 3,
        spaceBetween: 64,
			}
		}
	});
  
    var swiper = new Swiper('.swiper-container02', {
    navigation: { 
      nextEl: '.swiper-related-button-next02',
      prevEl: '.swiper-related-button-prev02',
    },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 2,
		spaceBetween: 32,
		breakpoints: {
			// 500px以上の場合
			500: {
				slidesPerView: 3,
        spaceBetween: 64,
			}
		}
	});
  
      var swiper = new Swiper('.swiper-container03', {
    navigation: { 
      nextEl: '.swiper-related-button-next03',
      prevEl: '.swiper-related-button-prev03',
    },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 2,
		spaceBetween: 32,
		breakpoints: {
			// 500px以上の場合
			500: {
				slidesPerView: 3,
        spaceBetween: 64,
			}
		}
	});
  
      var swiper = new Swiper('.swiper-container04', {
    navigation: { 
      nextEl: '.swiper-related-button-next04',
      prevEl: '.swiper-related-button-prev04',
    },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 2,
		spaceBetween: 32,
		breakpoints: {
			// 500px以上の場合
			500: {
				slidesPerView: 3,
        spaceBetween: 64,
			}
		}
	});
  
      var swiper = new Swiper('.swiper-container05', {
    navigation: { 
      nextEl: '.swiper-related-button-next05',
      prevEl: '.swiper-related-button-prev05',
    },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 2,
		spaceBetween: 32,
		breakpoints: {
			// 500px以上の場合
			500: {
				slidesPerView: 3,
        spaceBetween: 64,
			}
		}
	});
  
});